import './swancourt/style';
import FormStructure from './swancourt/form_structure';

export default FormStructure;